import { jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { clsx } from "clsx";
import Triangle from "./components/Triangle.js";
import { adjustPosition } from "./helpers/getPosition.js";
import { useOnScreenVariation } from "./useOnScreenVariation.js";
const TooltipWrapper = ({ containerClassName, contentClassName, position = 'top', children, message, offset, sectionClassName })=>{
    const [show, setShow] = useState(false);
    const [willHide, setWillHide] = useState(false);
    const [currentPosition, setCurrentPosition] = useState(position);
    const contentRef = useRef(null);
    const containerRef = useRef(null);
    const setContentPosition = useCallback(({ newPosition, top, bottom, left, right })=>{
        const tooltipContent = contentRef.current;
        if (!tooltipContent) return;
        setCurrentPosition(newPosition);
        tooltipContent.style.top = top ?? '';
        tooltipContent.style.bottom = bottom ?? '';
        tooltipContent.style.left = left ?? '';
        tooltipContent.style.right = right ?? '';
    }, [
        contentRef
    ]);
    const adjustTooltipPosition = useCallback(()=>{
        const content = contentRef.current;
        const container = containerRef.current;
        if (!content || !container) return;
        const contentPosition = adjustPosition({
            position,
            content,
            container,
            offset
        });
        setContentPosition(contentPosition);
    }, [
        contentRef,
        containerRef,
        position,
        offset,
        setContentPosition
    ]);
    useOnScreenVariation(adjustTooltipPosition, {
        runAtStart: true,
        message
    });
    const handleMouseEnter = ()=>{
        setShow(true);
        setWillHide(false);
    };
    const handleMouseLeave = ()=>{
        setWillHide(true);
    };
    useEffect(()=>{
        if (!willHide) return;
        const debounceHide = setTimeout(()=>{
            setShow(false);
            setWillHide(false);
        }, 300);
        return ()=>clearTimeout(debounceHide);
    }, [
        willHide
    ]);
    return /*#__PURE__*/ jsxs("span", {
        ref: containerRef,
        className: clsx(containerClassName, 'tw-relative'),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            children,
            /*#__PURE__*/ jsxs("div", {
                className: clsx('tw-pointer-events-none tw-absolute tw-flex tw-w-full tw-h-full tw-items-center tw-justify-center -tw-top-0.2 tw-left-0 tw-transition-opacity tw-duration-300', contentClassName, show && message ? 'tw-visible tw-opacity-100' : 'tw-invisible tw-opacity-0'),
                children: [
                    /*#__PURE__*/ jsx(Triangle, {
                        tooltipPosition: currentPosition,
                        offset: offset
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        ref: contentRef,
                        className: clsx('tw-font-body5 tw-flex tw-absolute tw-bg-neutral-dark-700 tw-text-neutral-light-100 dark:tw-bg-neutral-light-200 dark:tw-text-neutral-light-800 tw-p-0.8 tw-rounded-0.8 tw-z-dialog tw-max-w-lg tw-w-max', sectionClassName),
                        children: [
                            message,
                            /*#__PURE__*/ jsx("div", {})
                        ]
                    })
                ]
            })
        ]
    });
};
const TooltipWrapper_TooltipWrapper = TooltipWrapper;
export default TooltipWrapper_TooltipWrapper;
export { TooltipWrapper };
